export function parseWildCardUrl(name: string, wildcardUrl?: string): string {
	if (name === '') {
		console.error('Null Argument Error - name is an empty string, unable to generate links to view resource');
		return '';
	}
	if (!wildcardUrl) {
		console.error('Null Argument Error - WildCardUrl is null, unable to generate links to view resource');
		wildcardUrl = '';
	}

	const slug = name.replaceAll(' ', '-');

	if (wildcardUrl.endsWith('/')) {
		wildcardUrl = wildcardUrl.substring(0, wildcardUrl.length - 1);
	} else if (wildcardUrl.startsWith('/') && wildcardUrl.lastIndexOf('/') === 0) {
		wildcardUrl = wildcardUrl;
	} else if (wildcardUrl.includes('/')) {
		wildcardUrl = wildcardUrl.substring(0, wildcardUrl.lastIndexOf('/'));
	} else {
		wildcardUrl = wildcardUrl;
	}

	return `${wildcardUrl}/${slug}`;
}
